import gql from 'graphql-tag';
import cloneDeep from 'lodash/cloneDeep';
import { Game } from './lib/Game';

const SUBMISSION_POPUP_STATE = gql`
	query {
		showSubmissionPopup @client
	}
`;

const LOADING_STATE = gql`
	query {
		loading @client
	}
`;

// const GAME_QUERY = gql`
//   query($gameID: ID!) {
//     user @client{
//       id
//       game(gameID: $gameID) @client{
//         id
//         data
//       }
//     }
//   }
// `

export default {
	Mutation: {
		toggleShowSubmissionPopup: (obj, args, { cache }) => {
			const { showSubmissionPopup } = cache.readQuery({
				query: SUBMISSION_POPUP_STATE
			});
			cache.writeData({ data: { showSubmissionPopup: !showSubmissionPopup } });
			return null;
		},
		startLoading: (obj, args, { cache }) => {
			const { loading } = cache.readQuery({
				query: LOADING_STATE
			});
			cache.writeData({ data: { loading: !loading } });
			return null;
		},
		stopLoading: (obj, args, { cache }) => {
			const { loading } = cache.readQuery({
				query: LOADING_STATE
			});
			cache.writeData({ data: { loading: !loading } });
			return null;
		},
		setVariable: (
			obj,
			{ gameID, submission, name, year, value },
			{ cache, getCacheKey }
		) => {
			const id = getCacheKey({ __typename: 'Game', id: gameID });
			const fragment = gql`
				fragment gameFragment on Game {
					id
					data
				}
			`;
			const game = cache.readFragment({ fragment, id });
			const newGame = Game.fromDocument(game)
				.setVariable(name, year, value)
				.toDocument();
			newGame['__typename'] = 'Game';
			return newGame;
		},

		compute: (obj, { gameID }, { cache, getCacheKey }) => {
			const id = getCacheKey({ __typename: 'Game', id: gameID });
			const fragment = gql`
				fragment gameFragment on Game {
					id
					data
				}
			`;
			const game = cache.readFragment({ fragment, id });
			const newGame = Game.fromDocument(game)
				.compute()
				.toDocument();
			newGame['__typename'] = 'Game';
			return newGame;
		},
		readEmail: (obj, { gameID, emailID }, { cache, getCacheKey }) => {
			const id = getCacheKey({ __typename: 'Game', id: gameID });
			const fragment = gql`
				fragment gameFragment on Game {
					id
					data
				}
			`;
			const game = cache.readFragment({ fragment, id });
			const newGame = Game.fromDocument(game)
				.readEmail(emailID)
				.toDocument();
			newGame['__typename'] = 'Game';
			return newGame;
		},
		submit: (obj, { gameID }, { cache, getCacheKey }) => {
			const id = getCacheKey({ __typename: 'Game', id: gameID });
			const fragment = gql`
				fragment gameFragment on Game {
					id
					data
				}
			`;
			const game = cache.readFragment({ fragment, id });
			const newGame = Game.fromDocument(game)
				.submit()
				.toDocument();
			newGame['__typename'] = 'Game';
			return newGame;
		},
		setCashDecision: (obj, { gameID, value }, { cache, getCacheKey }) => {
			const id = getCacheKey({ __typename: 'Game', id: gameID });
			const fragment = gql`
				fragment gameFragment on Game {
					id
					data
				}
			`;
			const game = cache.readFragment({ fragment, id });
			const newGame = cloneDeep(game);
			newGame['__typename'] = 'Game';
			newGame.data.cashDecisions = value;
			newGame.data.cashDecisionsSaved = true;
			return newGame;
		}
	}
};
